/**
 * isPrivyEligible
 *
 * Returns true when a user is eligible to initiate identity verification.
 * A null privyLevel means the JWT claim is absent (level unknown); treat as 0 (unverified).
 * Level 0 users are eligible for verification.
 * Level 1+ users are already verified (or handled by the renewal flow).
 */
export function isPrivyEligible(privyLevel: number | null): boolean {
  return (privyLevel ?? 0) === 0;
}

/**
 * getPrivyDisplayLabel
 *
 * Maps internal PrivyLevel (0-indexed) to user-facing display label (1-indexed).
 * Level 0 → "Privy 1", Level 1 → "Privy 2".
 */
export function getPrivyDisplayLabel(level: number): string {
  return `Privy ${level + 1}`;
}
